import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  CreateProposalClientModel,
  DeleteProposalClientModel,
  SearchProposalClientModel,
} from '../../../models/proposal-client.model'

@Injectable({
  providedIn: 'root',
})
export class ScheduleDriverService {
  private baseUrl = environment.baseUrl
  private resource: string = 'AgendaMotorista'

  constructor(private httpClient: HttpClient) { }

  public createAgendaMotorista(
    model: any,
    // model: CreateProposalClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public editAgendaMotorista(
    model: any,
    // model: EditProposalClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit`,
      model,
    )
  }

  public deleteAgendaMotorista(
    id: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete/${id}`,
      id,
    )
  }



  public listPagedAgendaMotorista(
    page: number,
    rows: number = 15,
    id: any
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/ordem-servico/paginated/${id}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public searchAgendaMotorista(
    model: SearchProposalClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search`,
      model,
    )
  }

  public listAgendaMotorista(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listall`,
    )
  }

  public getAgendaMotoristabyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  public searchPagedAgendaMotorista(
    page: number,
    rows: number = 15,
    model: SearchProposalClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public listPagedFreeDriver(
    page: number,
    rows: number = 15,
    id: any
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/motoristas-livres?pageNumber=${page}&pageSize=${rows}`,
      id
    )
  }

  public listPagedScheduleDriverByOs(
    page: number,
    rows: number = 15,
    id: any
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/motoristas-ordem-servico?pageNumber=${page}&pageSize=${rows}`,
      id
    )
  }

}
